import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const UserProfileMenuButton = () =>
  import(/* webpackChunkName: "4-feat-userprofile-menubutton" */ './UserProfileMenuButton');

export default lazyLoadOnRender({ loader: UserProfileMenuButton });
